import { useState } from "react"

import { Outlet, Link } from "react-router-dom"
import { useSelector } from "react-redux"
import { selectCurrentRole } from "../features/auth/authSlice"
import { selectCrm } from "../features/crm/crmSlice"

import "./DashHeader.css"

const DashHeader = () => {
    const [navbarToggle, setNavbarToggle] = useState(false)

    const handleNavbarToggle = () => {
        setNavbarToggle(!navbarToggle)
    }

    const role = useSelector(selectCurrentRole)
    const crm = useSelector(selectCrm)

    const getUserLandingPage = () => {
        let landingPage
        if(role === "ADVISOR") {
            landingPage = `/dash/crm/${crm || 0}`
        } else if(role === "SUPPORT_STAFF") {
            landingPage = "/dash/support"
        } else {
            landingPage = "/dash"
        }

        return landingPage
    }

    return (
        <>
            <header className="dash-header active">
                <div className="container">
                    <Link to={getUserLandingPage()}>
                        <div className="logo-dark">Advisors Reserve</div>
                    </Link>

                    <nav className={"navbar" + (navbarToggle ? " active" : "")}>
                        <div className="navbar-top">
                            <Link to={getUserLandingPage()}>
                                <div className="navbar-top-logo">Advisors Reserve</div>
                            </Link>

                            <button className="nav-close-btn" aria-label="close menu" onClick={() => handleNavbarToggle()}>
                                <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
                            </button>
                        </div>

                        <ul className="navbar-list">
                            {
                                role === "EMPLOYEE" &&
                                    <>
                                        <Link to="/dash">
                                            <li>
                                                <a className="navbar-link" role="link">Extract</a>
                                            </li>
                                        </Link>
                                        <Link to="/dash/crmList">
                                            <li>
                                                <a className="navbar-link" role="link">Clients & Accounts</a>
                                            </li>
                                        </Link>
                                        <Link to="/dash/manageForms">
                                            <li>
                                                <a className="navbar-link" role="link">Forms</a>
                                            </li>
                                        </Link>
                                        <Link to="/dash/manageUser">
                                            <li>
                                                <a className="navbar-link" role="link">Manage User</a>
                                            </li>
                                        </Link>
                                    </>
                            }
                            {
                                role === "ADVISOR" &&
                                    <>
                                        <Link to={`/dash/crm/${crm || 0}`}>
                                            <li>
                                                <a className="navbar-link" role="link">Clients & Accounts</a>
                                            </li>
                                        </Link>
                                        <Link to={"/dash/forms"}>
                                            <li>
                                                <a className="navbar-link" role="link">Forms</a>
                                            </li>
                                        </Link>
                                        <Link to={"/dash/bulk"}>
                                            <li>
                                                <a className="navbar-link" role="link">Bulk Request</a>
                                            </li>
                                        </Link>
                                        <Link to={"/dash/bob"}>
                                            <li>
                                                <a className="navbar-link" role="link">Book of Business</a>
                                            </li>
                                        </Link>
                                    </>
                            }
                            {
                                role === "SUPPORT_STAFF" &&
                                    <>
                                        <Link to="/dash/support">
                                            <li>
                                                <a className="navbar-link" role="link">Advisors</a>
                                            </li>
                                        </Link>
                                    </>
                            }
                            {
                                (role === "SUPPORT_STAFF" || role === "ADVISOR") &&
                                    <>
                                        <Link to="/dash/customReports">
                                            <li>
                                                <a className="navbar-link" role="link">Reports</a>
                                            </li>
                                        </Link>
                                    </>
                            }
                        </ul>
                    </nav>
                    <Link to="/logout">
                        <div className="logout-button">
                            <div className="crm-button">Logout</div>
                        </div>
                    </Link>

                    <button className="nav-open-btn" aria-label="open menu" onClick={() => handleNavbarToggle()}>
                        <ion-icon name="menu-outline" aria-hidden="true"></ion-icon>
                    </button>

                    <div className={"overlay" + (navbarToggle ? " active" : "")} data-nav-toggler data-overlay onClick={() => handleNavbarToggle()}></div>
                </div>
            </header>

            <div className="dash-container">
                    <Outlet />  
            </div>
        </>

    )
}

export default DashHeader